import { Button, Card, Grid } from "@mui/material";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import RhfSelect from "../../../libs/rhf-mui/RhfSelect";
import CheckBox from "../../../libs/rhf-mui/ui/CheckBox";
import { Lang, SpwkUtil } from "../../dao/SpwkUtil";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { useGV } from "../../GV";
import AuthHelper from "../../heplers/AuthHelper";

type Props = {
  _UniAnswer: UniAnswer | null | undefined;
  _UniCommonForm: UniForm | null | undefined;

  IsSkipValid: boolean;
  set_IsSkipValid: React.Dispatch<React.SetStateAction<boolean>>;

  LangA: Lang;
  set_LangA: React.Dispatch<React.SetStateAction<Lang>>;

  LangB: Lang;
  set_LangB: React.Dispatch<React.SetStateAction<Lang>>;


  OnSkipValidChanged: (check: boolean) => void;

};

const UcDevTools = ({
  _UniAnswer,
  _UniCommonForm,

  IsSkipValid, set_IsSkipValid,
  LangA, set_LangA,
  LangB, set_LangB,

  OnSkipValidChanged,

  ...props }: Props) => {

  let ctx = useAppContext();
  let GV = useGV();

  let rhf = useFormContext();

  let rhf_lang = useForm();

  return (
    <Card sx={{ p: 4 }}>
      <Grid container>
        <Grid item container px={2}>
          <div style={{ color: '#DD6666' }}>answer: {_UniAnswer?.guid}</div>&nbsp;&nbsp;&nbsp;<div>member: {_UniAnswer?.member_guid}</div>
        </Grid>

        <Grid item container>
          <Grid item>
            {render_LangPicker()}
          </Grid>

          <Grid item pt={2} mx={1}>
            <Button variant="contained" onClick={btn_AdminLogout_Click}>
              登出
            </Button>
          </Grid>

          <Grid item pt={2} mx={1}>
            <Button variant="contained" onClick={btn_JSON_Click}>
              JSON
            </Button>
          </Grid>

          <Grid item pt={2} mx={1}>
            <Button type="submit" variant='contained' color='success' >
              SUBMIT
            </Button>
          </Grid>

          <Grid item pt={2} mx={1}>

            <CheckBox label={"不驗證"}
              markProps={{
                color: 'error',
                checked: IsSkipValid,
                onChange(event, checked) {
                  set_IsSkipValid(checked);
                  OnSkipValidChanged(checked);
                },
              }}
            />

          </Grid>


        </Grid>
      </Grid>
    </Card>
  );

  function btn_AdminLogout_Click() {
    AuthHelper.Logout(GV, ctx);
  }

  function btn_JSON_Click() {
    let data = rhf.getValues();

    data = SpwkUtil.僅保留有Data中有輸入的數值(data);
    MessageDialog.Show(ctx, JSON.stringify(data, null, 4), "JSON", {
      colorMeaning: "Success",
    });
  }

  function render_LangPicker() {
    return (
      <FormProvider {...rhf_lang}>
        <Grid item>
          <Grid container rowSpacing={{ xs: 2 }} columnSpacing={{ sm: 2 }} direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "center" }} justifyContent={{ sm: "center" }} mt={{ xs: 0 }}>
            <Grid item xs={12} sm={3} >
              <RhfSelect name="lang_A" label={"主語言"} sx={{ width: "150px" }} options={[
                { value: "CHI", label: "中文" },
                { value: "ENG", label: "英文" },
                { value: "IND", label: "印尼" },
                { value: "TGL", label: "菲律賓" },
                { value: "VIE", label: "越南" },
                { value: "THA", label: "泰國" },
              ]}
                defaultValue="CHI"
                onChange={(e) => {
                  set_LangA(e.target.value as Lang);
                }}
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <RhfSelect name="lang_B" label={"次語言"} sx={{ width: "150px" }} options={[
                { value: "CHI", label: "中文" },
                { value: "ENG", label: "英文" },
                { value: "IND", label: "印尼" },
                { value: "TGL", label: "菲律賓" },
                { value: "VIE", label: "越南" },
                { value: "THA", label: "泰國" },
                { value: "", label: "無次語言" },
                { value: "RHF_NAME", label: "RHF" },
                { value: "CODE", label: "CODE" },
                { value: "HIS", label: "HIS" },
                { value: "GOV", label: "GOV" },
              ]}

                onChange={(e) => {
                  if (e.target.value === '無次語言') {
                    set_LangB('');
                  } else {
                    set_LangB(e.target.value as Lang);
                  }
                }}

                size="small"
              />
            </Grid>
          </Grid>
        </Grid >
      </FormProvider>)
  }
};

export default UcDevTools;


